<template>
  <!--<div class="loading-overlay">-->
  <div class="modal-content">
    <div class="loading-spinner"></div>
    <p v-if="message">{{ message }}</p>
  </div>
</template>

<script setup>
import { defineProps } from "vue";

defineProps({
  message: {
    type: String,
    default: "Cargando...",
  },
});
</script>

<style scoped>
.modal-content {
  display: flex;
  height: 100%;
  align-items: center;
  justify-content: center;
  flex: 1 1 auto;
  height: 25vh;
  width: 30vw;
  color: var(--text-primary);
}

.loading-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.6);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  color: black;
  text-align: center;
}
.loading-spinner {
  border: 4px solid rgba(0, 0, 0, 0.1);
  border-left-color: var(--color-success);
  border-radius: 50%;
  width: 50px;
  height: 50px;
  animation: spin 1s linear infinite;
  margin-bottom: 10px;
}
@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

/* -------------------------------------------------------------------------- */
/* RESPONSIVE MOBILE STYLES                         */
/* -------------------------------------------------------------------------- */

/* Define el punto de corte (breakpoint) para móvil, por ejemplo, 768px */
@media (max-width: 768px) {
  /* Contenedor principal del modal */
  .modal-content {
    /* Fija la altura total del modal, aprovechando el espacio desde abajo */
    height: 40vh;
    width: 80vw;

    /* Asegura que el contenido interno pueda scrollear */
    overflow: hidden; /* Esto ya estaba, pero lo confirmamos */
  }
}
</style>
